/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonQuery from 'json-query';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import { Headings } from '../Header/Header';
import HeaderWrapper from '../Header/HeaderWrapper';
import List, { ListProperties } from '../List/List';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    titles: Headings[];
    dataKey: string;
    listItems: ListProperties;
    transformData?: boolean;
    functionToTransformData?: string;
    typographyClass?: string;
}

const MultiList = (props: commonTypes.WidgetInstanceProps) => {
    const data: any = props.data;
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, titles, dataKey, listItems, transformData, functionToTransformData } =
        widgetProperties || props;

    const multiList = JsonQuery(`${dataKey}`, { data }).value;

    let isRender = {
        renderList: true,
        data,
    };

    try {
        // eslint-disable-next-line no-new-func
        const transformFunction = Function(`${functionToTransformData}`)();
        const transformedProps = transformData && transformFunction(isRender);

        if (transformedProps) {
            isRender = { ...isRender, ...transformedProps };
        }
    } catch (e) {
        console.log(e);
    }

    return isRender?.renderList ? (
        <div
            className={`multi-list ${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
            css={css`
                ${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
        >
            <HeaderWrapper headings={titles} data={isRender.data} />
            <div className="multi-list-items">
                {multiList?.map((list: string, index: number) => {
                    return (
                        <List
                            key={index}
                            data={{ ...isRender.data, list }}
                            titles={listItems.titles}
                            dataKey={listItems.dataKey}
                            itemDataKey={listItems.itemDataKey}
                        />
                    );
                })}
            </div>
        </div>
    ) : null;
};

export default MultiList;
